import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

interface HeroSectionProps {
  onGetStarted: () => void;
}

const HeroSection = ({ onGetStarted }: HeroSectionProps) => {
  return (
    <section className="relative overflow-hidden py-20 px-4">
      <div className="absolute inset-0 bg-[var(--hero-gradient)] opacity-30" />
      
      <div className="container mx-auto max-w-4xl text-center relative z-10">
        <p className="text-lg md:text-xl font-bold text-primary mb-4 animate-in fade-in slide-in-from-bottom-4 duration-1000">
          Translator AI App
        </p>
        
        <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent animate-in fade-in slide-in-from-bottom-4 duration-1000">
          Break Down Language Barriers
        </h1>
        
        <p className="text-lg md:text-xl text-foreground/80 mb-8 max-w-2xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-150">
          Break down language barriers in seconds. Translate text or images accurately and securely with our professional multilingual AI translator.
        </p>
        
        <Button 
          size="lg" 
          onClick={onGetStarted}
          className="group shadow-lg hover:shadow-xl transition-all hover:[var(--hover-lift)]"
        >
          Get Started
          <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
        </Button>
      </div>
    </section>
  );
};

export default HeroSection;
